(function () {

  'use strict';

  function SiteService($cookies, localStorageService) {

    const OPEN_FOLDER_IDS_KEY = 'openFolderIds';
    const STORED_SITE_KEY = 'storedSite';

    let storageObject;

    if (localStorageService.isSupported) {
      storageObject = localStorageService;
    } else {
      storageObject = $cookies;
      storageObject.set = function (key, value) {
        return storageObject.put(key, value);
      };
    }

    if (!storageObject.get(OPEN_FOLDER_IDS_KEY)) {
      storageObject.set(OPEN_FOLDER_IDS_KEY, {});
    }

    function storeOpenFolderId(folderId) {
      const openFolderIds = storageObject.get(OPEN_FOLDER_IDS_KEY);
      openFolderIds[folderId] = true;
      storageObject.set(OPEN_FOLDER_IDS_KEY, openFolderIds);
    }

    function removeOpenFolderId(folderId) {
      const openFolderIds = storageObject.get(OPEN_FOLDER_IDS_KEY);
      delete openFolderIds[folderId];
      storageObject.set(OPEN_FOLDER_IDS_KEY, openFolderIds);
    }

    function retrieveOpenFolderIds() {
      return storageObject.get(OPEN_FOLDER_IDS_KEY);
    }

    function putSiteInStorage(site) {
      storageObject.set(STORED_SITE_KEY, site);
    }

    function getSiteFromStorage() {
      return storageObject.get(STORED_SITE_KEY);
    }

    function removeSiteFromStorage() {
      storageObject.set(STORED_SITE_KEY, undefined);
    }

    return {
      storeOpenFolderId,
      removeOpenFolderId,
      retrieveOpenFolderIds,
      putSiteInStorage,
      getSiteFromStorage,
      removeSiteFromStorage
    };
  }

  SiteService.$inject = ['$cookies', 'localStorageService'];

  angular
    .module('printix-admin')
    .service('SiteService', SiteService);

})();
